// extracted by mini-css-extract-plugin
export default {"stickyItem":"StatsDataGrid_stickyItem__5irWp"};